// extracted by mini-css-extract-plugin
module.exports = {"varselIKontekst":"VarselIKontekst_varselIKontekst__AZUo8"};